import store from '@/store';
import router from '@/router';


// components:

import Accordion from '@/components/globals/accordion.vue';
import AccordionItem from '@/components/globals/accordion-item.vue';
import AddressForm from '@/components/globals/address-form.vue';
import AppDownloadBadges from '@/components/globals/app-download-badges.vue';
import ApplyCardfreeOffer from '@/components/globals/apply-cardfree-offer.vue';
import ApplyDiscount from '@/components/globals/apply-discount.vue';
import AutocompleteInput from '@/components/globals/autocomplete-input.vue';
import BirthdayInput from '@/components/globals/birthday-input.vue';
import CardTypeIcon from '@/components/globals/card-type-icon.vue';
import Cart from '@/components/globals/cart/index.vue';
import CheckboxInput from '@/components/globals/checkbox-input.vue';
import CollectAccountInfo from '@/components/globals/collect-account-info.vue';
import CopyToClipboard from '@/components/globals/copy-to-clipboard.vue';
import CurrentDayMenuSchedule from '@/components/globals/current-day-menu-schedule.vue';
import CurrentDayStoreHours from '@/components/globals/current-day-store-hours.vue';
import DatePicker from '@/components/globals/date-picker.vue';
import DeliveryAddressForm from '@/components/globals/delivery-address-form.vue';
import DirectionsButton from '@/components/globals/directions-button.vue';
import EditGroupOrder from '@/components/globals/edit-group-order.vue';
import ExpandableSection from '@/components/globals/expandable-section.vue';
import FavoriteButton from '@/components/globals/favorite-button.vue';
import FormattedContent from '@/components/globals/formatted-content.vue';
import FormFieldset from '@/components/globals/form-fieldset.vue';
import GeolocationInput from '@/components/globals/geolocation-input.vue';
import GroupOrderLockedMessage from '@/components/globals/group-order-locked-message.vue';
import GuestArrivedButton from '@/components/globals/guest-arrived-button.vue';
import ImageLoader from '@/components/globals/image-loader.vue';
import ImageScroller from '@/components/globals/image-scroller.vue';
import InAppMessage from '@/components/globals/in-app-message.vue';
import InfoMessage from '@/components/globals/info-message.vue';
import InputError from '@/components/globals/input-error.vue';
import LoadingWrapper from '@/components/globals/loading-wrapper.vue';
import LocationSelector from '@/components/globals/location-selector.vue';
import LoyaltyPartialSignIn from '@/components/globals/loyalty-partial-sign-in.vue';
import LoyaltyPopupCard from '@/components/globals/loyalty-popup-card.vue';
import LoyaltyProgressRing from '@/components/globals/loyalty-progress-ring.vue';
import LoyaltyReceiptSummary from '@/components/globals/loyalty-receipt-summary.vue';
import LoyaltySummaryCard from '@/components/globals/loyalty-summary-card.vue';
import MainFooter from '@/components/globals/main-footer.vue';
import MenuItem from '@/components/globals/menu-item.vue';
import MenuItemChild from '@/components/globals/menu-item-child.vue';
import ModifierGroups from '@/components/globals/modifier-groups.vue';
import ModifierPortionGroup from '@/components/globals/modifier-portion-group.vue';
import ModifierSelectGroup from '@/components/globals/modifier-select-group.vue';
import OfferSummaryCard from '@/components/globals/offer-summary-card.vue';
import OpenTabFinishOrdering from '@/components/globals/open-tab-finish-ordering.vue';
import OpenTabOnboarding from '@/components/globals/open-tab-onboarding.vue';
import OrderItemDescriptionText from '@/components/globals/order-item-description-text.vue';
import OrderItems from '@/components/globals/order-items.vue';
import OrderItemsRoom from '@/components/globals/order-items-room.vue';
import OrderRoomErrors from '@/components/globals/order-room-errors.vue';
import PageHeader from '@/components/globals/page-header.vue';
import PaymentMethods from '@/components/globals/payment-methods/index.vue';
import PrivacyPolicy from '@/components/globals/privacy-policy.vue';
import ProgressRing from '@/components/globals/progress-ring.vue';
import QuantityInput from '@/components/globals/quantity-input.vue';
import RadioInput from '@/components/globals/radio-input.vue';
import ResetTableButton from '@/components/globals/reset-table-button.vue';
import SavedCards from '@/components/globals/saved-cards.vue';
import SearchInput from '@/components/globals/search-input.vue';
import SelectedLocationOrderDetails from '@/components/globals/selected-location-order-details.vue';
import SelectFavoriteStore from '@/components/globals/select-favorite-store.vue';
import SelectInput from '@/components/globals/select-input.vue';
import ShippingMethodSelector from '@/components/globals/shipping-method-selector.vue';
import SignIn from '@/components/globals/sign-in.vue';
import SignInWithFacebook from '@/components/globals/sign-in-with-facebook.vue';
import SignInWithGoogle from '@/components/globals/sign-in-with-google.vue';
import SimpleHeader from '@/components/globals/simple-header.vue';
import SmsReceiptOptIn from '@/components/globals/sms-receipt-opt-in.vue';
import SurveyLink from '@/components/globals/survey-link.vue';
import SvgIcon from '@/components/globals/svg-icon.vue';
import SvgIconLibrary from '@/components/globals/svg-icon-library.vue';
import SwitchInput from '@/components/globals/switch-input.vue';
import TabbedRoutes from '@/components/globals/tabbed-routes.vue';
import TermsAndConditions from '@/components/globals/terms-and-conditions.vue';
import TextInput from '@/components/globals/text-input.vue';
import TipSelection from '@/components/globals/tip-selection/index.vue';
import UpsellOrderItems from '@/components/globals/upsell-order-items.vue';
import UserList from '@/components/globals/user-list.vue';
import ValidatedForm from '@/components/globals/validated-form.vue';
import VerifyAccountCta from '@/components/globals/verify-account-cta.vue';
import YourPayment from '@/components/globals/your-payment.vue';
import BarcodeScanner from '@/components/globals/barcode-scanner.vue';


// Components that are redesigned
import Modal from '@/view/components/shared/modal/index.vue';
// import CfValidatedForm from '@/view/components/shared/cf-validated-form/index.vue';
import CfModifierGroups from '@/view/components/globals/cf-modifier-groups/index.vue'; // Need to import it here since its a recursive component

// directives:

import autoFocus from '@/directives/auto-focus';
import copyToClipboard from '@/directives/copy-to-clipboard';
import entrapFocus from '@/directives/entrap-focus';
import maskInput from '@/directives/mask-input';

// filters:

import cardNumber from '@/filters/card-number';
import dollars from '@/filters/dollars';
import initial from '@/filters/initial';
import kebabcase from '@/filters/kebabcase';
import lowercase from '@/filters/lowercase';
import miles from '@/filters/miles';
import moment from '@/filters/moment';
import momentCalendar from '@/filters/moment-calendar';
import phone from '@/filters/phone';
import timeOfDay from '@/filters/time-of-day';

import formatDate from '@/helpers/format/format-date';
import formatDateTime from '@/helpers/format/format-date-time';

// mixins:

import modals from '@/mixins/modals';

// helpers:

import validateCardExpiration from '@/helpers/validate-card-expiration';
import validateCardType from '@/helpers/validate-card-type';
import validateConfirmation from '@/helpers/validate-confirmation';
import validateCvv from '@/helpers/validate-cvv';
import validateFullName from '@/helpers/validate-full-name';
import validateMonthAndDay from '@/helpers/validate-month-and-day';
import validateMonthDayAndYear from '@/helpers/validate-month-day-and-year';
import validateName from '@/helpers/validate-name';
import validatePhoneNumber from '@/helpers/validate-phone-number';
import validatePostalCode from '@/helpers/validate-postal-code';
import validateStrongPassword from '@/helpers/validate-strong-password';

// third party:

import VClamp from '@/components/globals/v-clamp.vue';
import { defineRule, configure } from 'vee-validate';
import { all as allVeeRules } from '@vee-validate/rules';

import DocumentTitle from './plugins/document-title';
import VueQrcode from '@/components/globals/vue-qrcode.vue';

import { plugin as VueTippy } from 'vue-tippy';
import 'tippy.js/dist/tippy.css';
import 'v-calendar/style.css';
import { polyfill as seamlessScrollPolyfill } from 'seamless-scroll-polyfill';

/** Custom plugins */
import GoogleTagManagerPlugin from '@/plugins/google-tag-manager-plugin';
import NewRelicEventTrackingPlugin from './plugins/new-relic-event-tracking-plugin';
import FirebaseRtDb from './plugins/firebase-rtdb-plugin';

/** Services */
import GoogleMapsService from '@/services/google-maps-service';


function components(app) {
  app.component('Accordion', Accordion);
  app.component('AccordionItem', AccordionItem);
  app.component('AddressForm', AddressForm);
  app.component('AppDownloadBadges', AppDownloadBadges);
  app.component('ApplyCardfreeOffer', ApplyCardfreeOffer);
  app.component('ApplyDiscount', ApplyDiscount);
  app.component('AutocompleteInput', AutocompleteInput);
  app.component('BirthdayInput', BirthdayInput);
  app.component('CardTypeIcon', CardTypeIcon);
  app.component('Cart', Cart);
  app.component('CheckboxInput', CheckboxInput);
  app.component('CollectAccountInfo', CollectAccountInfo);
  app.component('CopyToClipboard', CopyToClipboard);
  app.component('CurrentDayMenuSchedule', CurrentDayMenuSchedule);
  app.component('CurrentDayStoreHours', CurrentDayStoreHours);
  app.component('DatePicker', DatePicker);
  app.component('DeliveryAddressForm', DeliveryAddressForm);
  app.component('DirectionsButton', DirectionsButton);
  app.component('EditGroupOrder', EditGroupOrder);
  app.component('ExpandableSection', ExpandableSection);
  app.component('FavoriteButton', FavoriteButton);
  app.component('FormattedContent', FormattedContent);
  app.component('FormFieldset', FormFieldset);
  app.component('GeolocationInput', GeolocationInput);
  app.component('GroupOrderLockedMessage', GroupOrderLockedMessage);
  app.component('GuestArrivedButton', GuestArrivedButton);
  app.component('ImageLoader', ImageLoader);
  app.component('ImageScroller', ImageScroller);
  app.component('InAppMessage', InAppMessage);
  app.component('InfoMessage', InfoMessage);
  app.component('InputError', InputError);
  app.component('LoadingWrapper', LoadingWrapper);
  app.component('LocationSelector', LocationSelector);
  app.component('LoyaltyPartialSignIn', LoyaltyPartialSignIn);
  app.component('LoyaltyPopupCard', LoyaltyPopupCard);
  app.component('LoyaltyProgressRing', LoyaltyProgressRing);
  app.component('LoyaltyReceiptSummary', LoyaltyReceiptSummary);
  app.component('LoyaltySummaryCard', LoyaltySummaryCard);
  app.component('MainFooter', MainFooter);
  app.component('MenuItem', MenuItem);
  app.component('MenuItemChild', MenuItemChild);
  app.component('Modal', Modal);
  app.component('CfModifierGroups', CfModifierGroups);
  app.component('ModifierGroups', ModifierGroups);
  app.component('ModifierPortionGroup', ModifierPortionGroup);
  app.component('ModifierSelectGroup', ModifierSelectGroup);
  app.component('OfferSummaryCard', OfferSummaryCard);
  app.component('OpenTabFinishOrdering', OpenTabFinishOrdering);
  app.component('OpenTabOnboarding', OpenTabOnboarding);
  app.component('OrderItemDescriptionText', OrderItemDescriptionText);
  app.component('OrderItems', OrderItems);
  app.component('OrderItemsRoom', OrderItemsRoom);
  app.component('OrderRoomErrors', OrderRoomErrors);
  app.component('PageHeader', PageHeader);
  app.component('PaymentMethods', PaymentMethods);
  app.component('PrivacyPolicy', PrivacyPolicy);
  app.component('ProgressRing', ProgressRing);
  app.component('QuantityInput', QuantityInput);
  app.component('RadioInput', RadioInput);
  app.component('ResetTableButton', ResetTableButton);
  app.component('SavedCards', SavedCards);
  app.component('SearchInput', SearchInput);
  app.component('SelectedLocationOrderDetails', SelectedLocationOrderDetails);
  app.component('SelectFavoriteStore', SelectFavoriteStore);
  app.component('SelectInput', SelectInput);
  app.component('ShippingMethodSelector', ShippingMethodSelector);
  app.component('SignIn', SignIn);
  app.component('SignInWithFacebook', SignInWithFacebook);
  app.component('SignInWithGoogle', SignInWithGoogle);
  app.component('SimpleHeader', SimpleHeader);
  app.component('SmsReceiptOptIn', SmsReceiptOptIn);
  app.component('SurveyLink', SurveyLink);
  app.component('SvgIcon', SvgIcon);
  app.component('SvgIconLibrary', SvgIconLibrary);
  app.component('SwitchInput', SwitchInput);
  app.component('TabbedRoutes', TabbedRoutes);
  app.component('TermsAndConditions', TermsAndConditions);
  app.component('TextInput', TextInput);

  app.component('TipSelection', TipSelection);
  app.component('UpsellOrderItems', UpsellOrderItems);
  app.component('UserList', UserList);
  app.component('ValidatedForm', ValidatedForm);
  app.component('VClamp', VClamp);
  app.component('VerifyAccountCta', VerifyAccountCta);
  app.component('VueQrcode', VueQrcode);
  app.component('YourPayment', YourPayment);
  app.component('BarcodeScanner', BarcodeScanner);
}



function directives(app) {
  app.directive('autoFocus', autoFocus);
  app.directive('copyToClipboard', copyToClipboard);
  app.directive('entrapFocus', entrapFocus);
  app.directive('maskInput', maskInput);
}



function filters(app) {
  app.config.globalProperties.$cardNumber = cardNumber;
  app.config.globalProperties.$dollars = dollars;
  app.config.globalProperties.$formatDate = formatDate;
  app.config.globalProperties.$formatDateTime = formatDateTime;
  app.config.globalProperties.$initial = initial;
  app.config.globalProperties.$kebabcase = kebabcase;
  app.config.globalProperties.$lowercase = lowercase;
  app.config.globalProperties.$miles = miles;
  app.config.globalProperties.$moment = moment;
  app.config.globalProperties.$momentCalendar = momentCalendar;
  app.config.globalProperties.$phone = phone;
  app.config.globalProperties.$timeOfDay = timeOfDay;
}



function mixins(app) {
  app.mixin(modals);
}



function plugins(app) {
  seamlessScrollPolyfill();

  store.dispatch('merchant/initialize');
  store.dispatch('session/initialize');

  /*
    Register all built-in @vee-validate/rules, then our 11 custom validators.
    NOTE: credit_card (Luhn check) is not included in @vee-validate/rules v4 —
    we define it manually below.
  */
  Object.entries(allVeeRules).forEach(([name, rule]) => defineRule(name, rule));

  defineRule('credit_card', (value) => {
    const digits = String(value).replace(/\D/g, '');
    let sum = 0;
    let isOdd = true;

    for (let i = digits.length - 1; i >= 0; i--) {
      let digit = parseInt(digits[i], 10);

      if (isOdd) {
        sum += digit;
      }
      else {
        digit *= 2;
        sum += digit > 9 ? digit - 9 : digit;
      }

      isOdd = !isOdd;
    }

    if (sum % 10 === 0) {
      return true;
    }

    return 'Invalid card number.';
  });

  defineRule('card_expiration', validateCardExpiration);
  defineRule('card_type', validateCardType);
  defineRule('confirmation', validateConfirmation);
  defineRule('cvv', validateCvv);
  defineRule('full_name', validateFullName);
  defineRule('month_and_day', validateMonthAndDay);
  defineRule('month_day_and_year', validateMonthDayAndYear);
  defineRule('name', validateName);
  defineRule('phone_number', validatePhoneNumber);
  defineRule('postal_code', validatePostalCode);
  defineRule('strong_password', validateStrongPassword);

  configure({
    validateOnInput: true,
    bails: false,
    generateMessage: (context) => {
      const field = context.label || context.field;

      if (context.field === 'cvv' && context.rule.name === 'required') {
        return 'CVV is required.';
      }

      if (context.field === 'zip' && context.rule.name === 'numeric') {
        return 'Invalid ZIP.';
      }

      if (context.field === 'zip' && context.rule.name === 'length') {
        return 'ZIP must be 5 digits.';
      }

      if (context.field === 'fullNameCreateAccount' && context.rule.name === 'required') {
        return 'Must enter first and last name.';
      }

      if ((context.field === 'firstNameCreateAccount' || context.field === 'lastNameCreateAccount') && context.rule.name === 'required') {
        return 'Must enter a valid name.';
      }

      const ruleMessages = {
        required: `The ${field} field is required`,
        email: `The ${field} field must be a valid email`,
        numeric: `The ${field} field may only contain numeric characters`,
        min: `The ${field} field is not long enough`,
        max: `The ${field} field is too long`,
        regex: `The ${field} field format is invalid`,
        confirmed: `The ${field} confirmation does not match`,
        length: `The ${field} field must be exactly ${context.rule?.params?.length || ''} characters`,
        credit_card: `The ${field} field is not a valid credit card number`
      };

      return ruleMessages[context.rule?.name] || `The ${field} field is not valid.`;
    }
  });


  app.use(DocumentTitle);
  app.use(VueTippy, {
    defaultProps: {
      animation: 'fade',
      arrow: true,
      duration: [200, 150],
      popperOptions: {
        modifiers: [
          {
            name: 'preventOverflow',
            enabled: true
          }
        ]
      }
    }
  });


  app.use(GoogleTagManagerPlugin, { store, router });

  app.use(NewRelicEventTrackingPlugin, { store });

  app.use(FirebaseRtDb, { store });
}

/** Global Services */
function services(app) {
  app.config.globalProperties.$googleMapsService = GoogleMapsService.init(store);
}

const globals = {
  initialize(app) {
    plugins(app);
    components(app);
    directives(app);
    filters(app);
    mixins(app);
    services(app);
  }
};



export default globals;
